import ClosedCirclesContainer from 'modules/circles/containers/ClosedCirclesContainer';

const ClosedCirclesView = props => <ClosedCirclesContainer {...props} />;

export default ClosedCirclesView;
